import { useMemo } from "react";
import { AdditiveBlending, Color, DoubleSide, MeshBasicMaterial, ShaderMaterial } from "three";
import { findAllObjectsStartsWithKey } from "../../../../utils/FindObjects";
import { useFrame } from "@react-three/fiber";
import DynamicTube from "../../DynamicTube";

import electronShader_frag from "../../shader/electrons_frag.glsl";
import electronShader_vert from "../../shader/electrons_vert.glsl";
import { useRef } from "react";
import MagneticField from "./MagneticField";
import CanvasUiContainer from "../../CanvasUiContainer";
import DescriptionBox from "../../DescriptionBox";

const HowitworksProcess2 = ({ scene, ...props }) => {
  const pathPoints = useMemo(() => {
    var points = findAllObjectsStartsWithKey("Electron_Point", scene);

    points.sort((a, b) => {
      var intA = parseInt(a.name.replace("Electron_Point (", "").replace(")", ""));
      var intB = parseInt(b.name.replace("Electron_Point (", "").replace(")", ""));

      if (intA < intB) {
        return -1;
      }
      if (intA > intB) {
        return 1;
      }
      return 0;
    });

    return points;
  }, []);

  var mat = useMemo(() => {
    // var mat = new MeshBasicMaterial({
    //   wireframe: true,
    //   color: 0xff0000,
    //   depthWrite: false,
    //   depthTest: false,
    //   transparent: true,
    // });

    var mat = new ShaderMaterial({
      fragmentShader: electronShader_frag,
      vertexShader: electronShader_vert,
      // vertexColors: true,
      transparent: true,
      depthWrite: false,
      depthTest: false,
      side: DoubleSide,
      // blending: AdditiveBlending,
      uniforms: {
        uTime: {
          value: 0,
        },
        uSpeed: {
          value: 1,
        },
        uBaseColor: {
          value: new Color("#e5ff00"),
        },
        uBaseColorPower: {
          value: 4,
        },
        uSize: {
          value: 0.005,
        },
        uStep: {
          value: 0.9,
        },
        uStepRange: {
          value: 0.09,
        },
      },
    });

    return mat;
  }, []);

  const sine = useRef(0);
  const sineTime = useRef(0);
  const magField = useRef();

  const animationSpeed = 0.7;

  useFrame(({ clock }) => {
    sine.current = Math.sin(clock.elapsedTime * animationSpeed);
    sineTime.current += sine.current * 0.003;
    if (mat) {
      mat.uniforms.uTime.value = sineTime.current;
    }
    if (magField.current) {
      magField.current.setOpacity(sine.current * sine.current);
      magField.current.setFlipped(sine.current < 0);
    }
  });

  return (
    <group>
      <DynamicTube pointRefs={pathPoints} material={mat} segments={190} tubeRadius={0.004} />
      <MagneticField scene={scene} ref={magField} />
      <CanvasUiContainer>
        <DescriptionBox>L4_INDUCTION_HEATING_MAGNETIC_FIELD_DESCRIPTION</DescriptionBox>
      </CanvasUiContainer>
    </group>
  );
};

export default HowitworksProcess2;
